import axios from "axios";
import { baseUrl } from "../Base_url";
const userData=JSON.parse(localStorage.getItem('recoil-persist'))
let token=""
if(userData){
  if(userData.KT_app){
    ////console.loguserData.KT_app)
    token=userData.KT_app.token
  }
}
export const getAllDevice = async (token,pages,limits,orderBy,order) => {
    try {
      const res = await axios.get(`${baseUrl}/district-admin/school-district/device?page=${pages}&limit=${limits}&orderBy=${orderBy}&order=${order}`,{
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e.response.data.data };
      return err;
    }
  };
  export const createDevice = async (data) => {
    try {
      const res = await axios.post(`${baseUrl}/admin/device/create`,data,{
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e.response.data.data };
      return err;
    }
  };
  
  export const editDevice = async (id,data) => {
    try {
      const res = await axios.put(`${baseUrl}/admin/device/${id}`,data,{
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e.response.data.data };
      return err;
    }
  };
  export const getDeviceDetails = async (id) => {
    try {
      const res = await axios.get(`${baseUrl}/admin/device/${id}`,{
        headers: { Authorization: `Bearer ${token}` },
      });
      return { error: false, res: res };
    } catch (e) {
      const err = { error: true, data: e.response.data.data };
      return err;
    }
  };
  
  
  